import { SALE_ROUTE_API } from '../../constants';

export const SALES_EXPORT_ROUTE = SALE_ROUTE_API;
export const SALES_ADMIN_ROLES = ['superadministrator', 'administrator'];

// The legacy Laravel sales report's columns minus the KTP/NPWP image link.
// emailOnly columns need joins the list payload lacks; adminOnly ones are
// stripped for non-admins in both modes.
export const SALES_EXPORT_COLUMNS = [
  { name: 'sale_id' }, { name: 'order_date' }, { name: 'invoice_number' }, { name: 'offer_status' }, { name: 'order_status' },
  { name: 'ka_verified_by' }, { name: 'ka_verified_date' },
  { name: 'payment_method' }, { name: 'payment_via' }, { name: 'acquiring_bank', emailOnly: true },
  { name: 'product_price' }, { name: 'seller_price' }, { name: 'total_amount' }, { name: 'total_adjusted_amount' },
  { name: 'customer_paid_at' }, { name: 'buyers_message' }, { name: 'notes', emailOnly: true },
  { name: 'discount' }, { name: 'shipping_cost' }, { name: 'shipping_discount' }, { name: 'subsidy_price' }, { name: 'tax' },
  { name: 'api_fee' }, { name: 'processing_fee' }, { name: 'amount_before_discount', emailOnly: true }, { name: 'amount_paid_for_goods', emailOnly: true },
  { name: 'payable_courier_price', emailOnly: true }, { name: 'courier' }, { name: 'courier_service' }, { name: 'profit' },
  { name: 'seller_email' }, { name: 'seller_mobile_number', adminOnly: true, emailOnly: true }, { name: 'seller_address', adminOnly: true, emailOnly: true },
  { name: 'ktp_npwp', adminOnly: true, emailOnly: true }, { name: 'type_id_card', adminOnly: true, emailOnly: true },
  { name: 'buyer' }, { name: 'shipping_info', emailOnly: true }, { name: 'preorder_indicator' }, { name: 'rack' },
  { name: 'product' }, { name: 'category' }, { name: 'size_us' }, { name: 'coupon_code' }
];

const num = v => (v === null || v === undefined ? '' : v);
const titleWords = s => String(s || '').split('_').filter(Boolean).map(w => w[0].toUpperCase() + w.slice(1)).join(' ');

// saleRow flattens one Go /admins/sales item into the download columns.
export const saleRow = item => {
  const offer = item.offer || {};
  const userSell = offer.user_sell || {};
  const seller = userSell.user || {};
  const product = item.sale_product || {};
  const size = product.size || {};
  return {
    sale_id: item.id,
    order_date: item.created_at,
    invoice_number: item.invoice_number,
    offer_status: offer.status,
    order_status: item.status,
    ka_verified_by: item.ka_verified_by,
    ka_verified_date: item.ka_verified_date,
    payment_method: titleWords(offer.payment_method),
    payment_via: offer.payment_via,
    product_price: num(item.price),
    seller_price: num(item.seller_price),
    total_amount: num(offer.total_amount),
    total_adjusted_amount: num(offer.total_adjusted_amount),
    customer_paid_at: item.customer_paid,
    buyers_message: item.notes,
    discount: num(item.discount),
    shipping_cost: num(offer.ka_courier_price),
    shipping_discount: num(offer.ka_courier_discount),
    subsidy_price: num(item.subsidy_price),
    tax: num(item.tax),
    api_fee: num(offer.api_fee),
    processing_fee: num(offer.processing_fee_calculated),
    courier: offer.ka_courier,
    courier_service: offer.ka_courier_option,
    profit: item.seller_price === null || item.seller_price === undefined ? '' : Number(item.price) - Number(item.seller_price),
    seller_email: seller.email,
    buyer: item.buyer_email,
    preorder_indicator: product.pre_order ? 1 : 0,
    rack: userSell.rack,
    product: product.display_name,
    category: product.category_name,
    size_us: size.US,
    coupon_code: item.voucher_code
  };
};

export const pickColumns = (row, columns) => {
  const out = {};
  columns.forEach(c => { out[c] = row[c]; });
  return out;
};
